import React from 'react';
import { Route } from 'react-router-dom';
import { getLogger } from '@cld/upload-widget';

const logger = getLogger();

const RouteWithSubRoutes = (props) => {
  const renderUsingRender = (route) => {
    logger.log(`[RouteWithSubRoutes]: rendering route for path: '${props.path || ''}' with render method with info: `, route);
    return props.render ? props.render({ ...props, ...route }) : null;
  };

  const renderUsingComponent = (route) => {
    logger.log(`[RouteWithSubRoutes]: rendering route for path: '${props.path || ''}' with component with route info: `, route);
    return props.component ? <props.component {...props} route={route} /> : null;
  };

  return (
    <Route
      path={props.path}
      render={
        props.render
          ? (route) =>
              // route provided render method
              renderUsingRender(route)
          : props.component
          ? // route provided component
            (route) => renderUsingComponent(route)
          : undefined
      }
    >
      {props.children}
    </Route>
  );
};

RouteWithSubRoutes.defaultProps = {
  path: '',
  render: null,
  component: null,
  children: null,
};

export default RouteWithSubRoutes;
